export const PROJECT_STATS_URL = '/';
export const GLOBAL_ADMIN_STATS_URL = '/global-admin-stats';
